import i18next from '../../../strings/i18n/i18n';
import { PAYMENT_REMINDER_MAX_DAYS } from '../../../const/alertsConfig';
var getDropDownAlertOptions = function () {
    var options = [];
    for (var i = 1; i <= PAYMENT_REMINDER_MAX_DAYS; i += 1) {
        var dayLabel = i === 1 ? i18next.t('dropdown.day') : i18next.t('dropdown.days');
        options.push({ label: "".concat(i, " ").concat(dayLabel), value: "".concat(i) });
    }
    return options;
};
export default getDropDownAlertOptions;
